// Unità di misura dei byte nella lingua (2026-09-17, con il francese).
// In francese l'ottetto e' "o": Ko, Mo, Go, To — "1 TB" scritto a un francese
// tecnico si nota subito. Le altre lingue tengono B/kB/MB/GB/TB come oggi.
const FR = { B: 'o', kB: 'Ko', KB: 'Ko', MB: 'Mo', GB: 'Go', TB: 'To' };
export function unitaByte(lingua, unita) {
  if (lingua === 'fr') return FR[unita] || unita;
  return unita;
}
